export default __webpack_public_path__ + "static/media/bmc.439d4faf.png";